import React from 'react'

import cromacer  from "../images/cromacer.png"
import physiocer from "../images/physiocer.jpg";
import xaltum from "../images/xaltum.png";
import physio from "../images/physio.png";

const Certificate = () => {
    const certificate = [
        {
          id: 1,
          src: cromacer,
          name:"Mern Certificate",
          href: "/merncer.pdf",
          download: true,
          
        },
        {
          id: 2,
          src: physiocer,
          name:"Intership Certificate",
          href: "/physiointer.pdf",
          download: true,
        },
        {
          id: 3,
          src: xaltum,
          name:"xaltum Offer",
          href: "/xaltumOffer.pdf",
          download: true,
          
        },
        {
          id: 4,
          src: physio,
          name:"Physio offer",
          href: "/physioOffer.pdf",
          download: true,
          
        },
        
      ];
  return (
    <div
    name="offer&certificate"
    className="bg-gradient-to-b  from-black via-black to-gray-800 w-full text-white md:h-screen"
  >
    <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
      <div className="pb-8">
        <p className="text-4xl font-bold inline border-b-4 border-gray-500">
          Offers And Certificates
        </p>
        <p className="py-6">My offer letters and certificates</p>
      </div>

      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0">
        {certificate.map(({ id, src,name,href,download }) => (
          <div key={id} className="shadow-md shadow-gray-600 rounded-lg">
            <img
              src={src}
              alt=""
              className="rounded-md duration-200 hover:scale-105"
            />
            <p className="flex py-2 justify-center">{name}</p>
            <div className="flex items-center justify-center">
              
              <a href={href} download={download} target="_blank"  rel="noreferrer" className="w-1/2 px-6 py-3 m-4 duration-200 hover:scale-105">
                Download
              </a>
             
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
  )
}

export default Certificate